import axios from 'axios';

// eslint-disable-next-line import/no-unresolved
import { CONFIG } from 'src/config-global';

// ----------------------------------------------------------------------

// <-------Backup Axios Instance------->
const axiosInstance = axios.create({ baseURL: CONFIG.site.serverUrl });
const BRANCH_SESSION_KEY = 'selected_branch';
const BRANCH_SHORT_KEY = 'branches_short_key';

axiosInstance.interceptors.request.use(
  (config) => {
    const IsLoginAPI = '/auth/login';

    if (!config.url.includes(IsLoginAPI)) {
      if (typeof window !== 'undefined') {
        let branchData = null;
        const parsedBranch = JSON.parse(localStorage.getItem(BRANCH_SESSION_KEY));
        branchData = parsedBranch;

        if (!branchData) {
          const shortBranch = JSON.parse(localStorage.getItem(BRANCH_SHORT_KEY));
          branchData = shortBranch;

          if (!branchData) {
            return console.error('No branch selected');
          }
        }

        const branch = {
          Branch_Code: branchData.branchCode,
          Branch_Name: branchData.branchName,
          Branch_Short: branchData.branchShort,
          Sub: branchData.sub,
        };

        config.data = { ...config.data, ...branch };

        // if (config.data instanceof FormData) {
        //   Object.entries(branch).forEach(([key, value]) => {
        //     config.data.append(key, value);
        //   });
        // } else if (typeof config.data === 'object') {
        //   config.data = { ...config.data, ...branch };
        // }

        const jwtToken = localStorage.getItem('jwt_access_token');
        // console.log(jwtToken);
        if (!jwtToken) return console.error('No token found');

        config.headers.Authorization = `Bearer ${jwtToken}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong!')
);

export default axiosInstance;
// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosInstance.get(url, { ...config });

    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

export const postFetcher = async (args, data, name = '') => {
  console.log(name);
  try {
    const [url, config] = Array.isArray(args) ? args : [args];
    console.log(`🔄 postFetcher called! URL: ${url}, Data:`, data);
    const res = await axiosInstance.post(url, data, { ...config });
    console.log(res);
    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

export const postFetcher1 = async (args, data, name = '') => {
  console.log(name);
  try {
    const [url, config] = Array.isArray(args) ? args : [args];
    console.log(`🔄 postFetcher called! URL: ${url}, Data:`, data);

    const res = await axiosInstance.post(url, data, { ...config });
    console.log('✅ Response from API:', res);

    return res;
  } catch (error) {
    console.error('❌ Failed to fetch:', error);
    throw error;
  }
};

export const postFetchertwo = async (args, data, name = '') => {
  console.log('Fetching with name:', name);
  try {
    const [url, config] = Array.isArray(args) ? args : [args];
    console.log(`🔄 postFetcher called! URL: ${url}, Data:`, data);

    const res = await axiosInstance.post(url, data, { ...config });

    console.log('Raw API Response:', res.data); // ตรวจสอบข้อมูลที่ได้รับจาก API
    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

export const postFetcher2 = async (args, data) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosInstance.post(url, data, { ...config });
    console.log(res);
    return res;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

export const putFetcher = async (args, data) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];
    const res = await axiosInstance.put(url, data, { ...config });
    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

export const deleteFetcher = async (args, data) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];
    const res = await axiosInstance.delete(url, { data, ...config });
    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

export const fetcherWithToken = async (requestUrl) => {
  const jwtToken = localStorage.getItem('jwt_access_token');
  if (!jwtToken) {
    console.error('❌ Unauthorized: No token found');
    throw new Error('Unauthorized: No token found');
  }

  try {
    console.log('📡 Fetching from:', requestUrl);
    const response = await axiosInstance.get(requestUrl, {
      headers: { Authorization: `Bearer ${jwtToken}` },
    });
    return response.data;
  } catch (error) {
    console.error('❌ API Error:', error.response?.data || error.message);
    throw error;
  }
};

// ----------------------------------------------------------------------

export const endpoints = {
  // Dashboard
  agilis: {
    overview: '/dashboard/overview',
    menu: '/dashboard/getMenuAccess',
    branch: '/dashboard/branch',
    srmstatus: '/receivecase/getsrmstatus',
    inbound: {
      getPallet: '/inbound/getpallet',
      checkPallet: '/inbound/checkpallet',
      addPallet: '/inbound/addPallet',
      getProduct: '/inbound/getproduct',
      removePallet: '/inbound/cancelPallet',
    },
    dc: {
      outbound: '/dashboard/getBOutbound',
    },
    center: {
      userSearch: '/center/userSearch',
      getAccessList: '/center/getAccessList', // ส่ง EmpCode, Level รับ preset ข้อมูลมาโชว์
      getAccessLevel: '/center/getAccessLevel', // ส่ง EmpCode สำหรับ Get Role Level
      userUpdate: '/center/userUpdate', // ส่ง Empcode และ Level เพื่อ update ให้ user
      saveMaster: '/center/master/saveMaster',
      getMaster: '/center/master/getMaster',
      getMenuList: '/dashboard/getMenuList',
    },
    general: {
      queue: '/general/getQueue',
      utilization: '/general/getData',
      utilizationGroup: '/general/getPalletGroup',
      utilizationCallPallet: '/general/PalletGroupCall',
      utilizationGroupPallet: '/general/UpdatePallet',
      reportUtilization: (start_date = null, end_date = null) =>
        `/general/getPalletDate?start_date=${start_date}&end_date=${end_date}`,
      palletrack: '/general/getRack',
      checkpicking: (doc_num = '', date = '',endDate='') =>
        `/general/getShipping?doc_num=${doc_num}&date=${date}&enddate=${endDate}`,
      countStock: '/general/getCheck',
      checkPallet: 'general/getCheck2',
      checkDiff: 'general/checkDiff',
      callPallet: '/general/callPallet',
      getLookup: '/general/getLookup',
      insertQueue: '/general/insertQueue',
      cancelWorkQueue: '/general/cancelWorkQueue', // ยกเลิกทำงาน
      cancelOrderQueue: '/general/cancelOrderQueue', // ยกเลิกคำสั่ง
      endWorkQueue: '/general/endWorkQueue',
      getRop: '/general/getRop',
      updateRop: '/general/updateRop',
      getCheck: '/general/getCheck',
    },
    outbound: {
      callPallet: {
        getPalletData: '/outbound/getPalletData',
        callPallet: '/outbound/callPallet',
      },
      adjuststock: {
        getDoc: '/outbound/getdoc',
        getDocDt: '/outbound/getdocdt',
        getNewRow: '/outbound/getnewrow',
        getProduct: '/outbound/getProduct',
        insertBill: '/outbound/createDoc',
        cancelBill: '/outbound/cancelDoc',
        approveBill: '/outbound/approveDoc',
        payBill: '/outbound/payDoc',
      },
      adjustdamagedstock: {
        getDocHd: '/outbound/adjuststock/getDocHead',
        getDocDt: '/outbound/adjuststock/getDocDetail',
        selectPl: '/outbound/adjuststock/selectPallet',
        getNewRow: '/outbound/adjuststock/getNewRow',
        createDoc: '/outbound/adjuststock/createDoc',
        getBill: '/outbound/adjuststock/getBill',
        approveAdjustBill: '/outbound/adjuststock/approveBill',
      },
      requisition: {
        getDoc: '/outbound/getdoc',
        getDocDt: '/outbound/getdocdt',
        getNewRow: '/outbound/getnewrow',
        getProduct: '/outbound/getProduct',
        insertBill: '/outbound/createDoc',
        cancelBill: '/outbound/cancelDoc',
        approveBill: '/outbound/approveDoc',
        payBill: '/outbound/payDoc',
      },
      transfer: {
        getDocHead: '/outbound/tranfer/getDocHead', // ส่ง startdate enddate
        getDocDetail: '/outbound/tranfer/getDocDetail', // ส่ง tranferid
        getDocHead2: '/outbound/tranfer/getDocHead_2', // ส่ง startdate enddate
        getDocDetail2: '/outbound/tranfer/getDocDetail_2', // ส่ง tranferid
        insertData: '/outbound/tranfer/insertTranfer', // ส่ง tranferid
      },
    },
    report: {
      getService: (startDate = null, endDate = null) =>
        `/report/getService?startDate=${startDate}&endDate=${endDate}`,
      getMobile: (startDate = null, endDate = null) =>
        `/report/getMobile?startdate=${startDate}&enddate=${endDate}`,
      getStack: '/report/getStack',
    },
    admin: {
      getcyclecount: '/report/cyclecount/getReport',
      getropchart: '/admin/ropchart',
      getUtilizationAll: '/report/utilize/getReport',
      getmoniter: '/admin/getShelfStatus',
      getasrsForm: '/admin/asrsForm',
      getstockNotMatch: '/admin/getStockNotMatch',
      getpalletWaiting: '/admin/getPalletStatus',
      getrop: '/admin/getROP',
      getdisCharge: '/admin/getdisCharge',
      getOutBound: '/dashboard/getOutbound',
      announcements: '/admin/announcements',
      announcementsCreate: '/admin/announcements/create',
      announcementsEdit: '/admin/announcements/edit',
      announcementsNoCache: '/admin/announcements/nocache',
      getShelfStatus: '/admin/getShelfStatus',
      facescan: '/admin/faceverify',
      faceregister: '/admin/uploadImage',
      licenseplate: '/admin/licenseplate',

      // ========== Breakdown ==========
      breakdownData: `/breakdown/getBreakdownData`,
      getdataBreakdown: `/getdataBreakdown`,
      getbranchShortname: `/breakdown/branchShortname`,
      branchBreakdownRankingData: `/breakdown/getBranchBreakdownRankingData`,
      breakdownByYearRange: `/breakdown/getBreakdownByYearRange`,
      addBreakdownRecord: `/breakdown/addBreakdownRecord`,
      updateBreakdownRecord: '/breakdown/updateBreakdownRecord',
      // ===========================================
      servicegetReport: `/report/service/getReport`,
      getCaseStatus: `/admin/case-status-team`,

      fixCase: {
        getPallet: `/location/check`,
        getRevertLocation: `/location/getrevert`,
        createLocation: `/location/create`,
        deleteLocation: `/location/delete`,
        revertLocation: `/location/revert`,
      },

      receiveCase: {
        get: {
          allItems: `/branch2/Getall`,
          branches: `/branch/Getall-branch`,
          get_employee: `/Employee/GetEmployeesall`,
          img: `/img`,
          levelurgencies: `/levelUrgent/Getall-levelUrgent`,
          main_case: `/maincase/get-all-maincases`,
          receive_case: `/receivecase/getreceivecase`,
          receivecaseJoin: `/receivecase/getreceivecase`,
          status: `/status/get-all-statuses`,
          sub_case: `/subcase-type/get-all-subcase-types`,
          subcase: `/subcase`,
          subcasejoin: `/sub_casejoin`,
          team: `/team/get-all-teams`,
          user: `/users/GetAll-Users`,
        },
        post: {
          branchesPost: `/branch/create-branch`,
          get_employeePost: `/Employee/createEmployee`,
          imgPost: `/upload-image`,
          levelurgenciesPost: `/levelUrgent/create-levelUrgent`,
          main_casePost: `/maincase/create-maincase`,
          receive_casePost: `receivecase/insert`,
          statusPost: `/status/create-status`,
          sub_casePost: `/subcasedata`,
          subcasePost: `/subcase`,
          teamPost: `/team/add-team`,
          userPost: `/auth/register`,
        },
        put: {
          branchesUpdate: `/branch/update/:id`,
          get_employeeUpdate: `/Employee/update/:id`,
          imgUpdate: `/img/:id`,
          levelurgenciesUpdate: `/levelUrgent/update/:id`,
          main_caseUpdate: `/maincase/update/:id`,
          receive_caseUpdate: `/receivecase/updatecase/:id`,
          statusUpdate: `/status/update/:id`,
          sub_caseUpdate: `/subcasedata/:id`,
          subcaseUpdate: `/subcase`,
          teamUpdate: `/team/update/:id`,
          userUpdate: `/users/:id`,
          updateBreakdownRecord: '/breakdown/updateBreakdownRecord',
        },
        delete: {
          branchesdelete: `//branches/:branch_id`,
          get_employeedelete: `/employee/:id`,
          imgdelete: `/img/:id`,
          levelurgenciesdelete: `/levelurgencies/:id`,
          main_casedelete: `/main-cases/:id`,
          receive_casedelete: `/receivecase/deletecase/:id`,
          statusdelete: `/status/delete/:id`,
          sub_casedelete: `/subcasedata/:id`,
          subcasedelete: `/subcase`,
          teamdelete: `/team/delete/:id`,
          userdelete: `/users/:id`,
        },
      },
    },
  },
  // Minimals
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    signIn: '/auth/login',
    signUp: '/api/auth/sign-up',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
};
